import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-97">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-98">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-bakery-brown/70 backdrop-blur-sm" onClick={onClose} data-id="element-99" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="relative bg-bakery-cream rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden" data-id="element-100">
            <div className="flex items-center justify-between p-6 border-b border-bakery-tan" data-id="element-101">
              <h2 className="text-2xl font-serif font-bold text-bakery-brown" data-id="element-102">
                {title}
              </h2>
              <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-bakery-tan/50 transition-colors" aria-label="Cerrar" data-id="element-103">
                <XIcon className="w-5 h-5 text-bakery-brown" data-id="element-104" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-bakery-brown/80 leading-relaxed space-y-4" data-id="element-105">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}